export const DEFAULT_DATEPICKER_DEBOUNCE_TIME = 300;
